import { BFF_SEARCHED_PRODUCT_LOAD,BFF_SEARCHED_PRODUCT_LOAD_FAIL,BFF_SEARCHED_PRODUCT_LOAD_SUCCESS } from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case BFF_SEARCHED_PRODUCT_LOAD:
      return {
        ...state,
        loading: true,
      };
    case BFF_SEARCHED_PRODUCT_LOAD_SUCCESS:
      if (action && action.result && action.result.suggestion && action.result.suggestion.categories && action.result.suggestion.categories.length === 0) {
        const products = action.result.suggestion.products;
        action.result.suggestion = state.data.suggestion;
        action.result.suggestion.products = products;
      }
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case BFF_SEARCHED_PRODUCT_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}
